<template>
    <div>
        <base-navigation></base-navigation>
<br>
<br>
   
    <div class="winner-container">
      <h2>🎉 Lucky Draw 🎉</h2>
  
      <div v-if="loading" class="shuffling">Shuffling...</div>
      <div v-else-if="winner" class="winner-name">WINNER: {{ winner }}</div>
      <div v-else class="no-winner">Click to shuffle and pick a name</div>
  
      <button @click="getRandomWinner" :disabled="loading">
        {{ loading ? 'Picking...' : 'Shuffle & Pick' }}
      </button>
    </div>
</div>
  </template>
  
  <script>
  export default {
    name: 'RandomWinner',
    data() {
      return {
        winner: '',
        loading: false
      };
    },
    methods: {
      async getRandomWinner() {
        this.loading = true;
        this.winner = '';
  
        try {
          const response = await fetch('https://api.roberms.com/fundraise/random-winner');
          const data = await response.json();
  
          // Simulate shuffling animation delay
          setTimeout(() => {
            this.winner = data.selected_name;
            this.loading = false;
          }, 1500);
        } catch (error) {
          console.error('Error fetching winner:', error);
          this.loading = false;
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .winner-container {
    text-align: center;
    padding: 2rem;
    background: #f7f9fc;
    border-radius: 10px;
    box-shadow: 0 0 12px rgba(0,0,0,0.1);
    max-width: 400px;
    margin: auto;
    font-family: Arial, sans-serif;
  }
  
  .shuffling {
    font-size: 1.5rem;
    color: #888;
    animation: blink 1s infinite;
  }
  
  @keyframes blink {
    0%, 100% { opacity: 1; }
    50% { opacity: 0; }
  }
  
  .winner-name {
    font-size: 2rem;
    font-weight: bold;
    color: #2e8b57;
    margin-bottom: 1rem;
  }
  
  button {
    padding: 10px 20px;
    font-size: 1rem;
    background: #3498db;
    color: #fff;
    border: none;
    border-radius: 8px;
    cursor: pointer;
  }
  
  button:disabled {
    background: #95a5a6;
    cursor: not-allowed;
  }
  </style>
  